import { useEffect, useRef, useState } from 'react'

import QuoteAquaIcon from '../../../../public/assets/quoteAqua'
import QuoteGreenIcon from '../../../../public/assets/quoteGreen'
import QuotePurpleIcon from '../../../../public/assets/quotePurple'
import { PhnxImageHolder } from '../../01-atoms/ImageHolder/ImageHolder'
import styles from './Testimonies.module.css'

export type TestimoniesItems = {
  variant: 'primary' | 'secondary' | 'tertiary' | 'quaternary'
  description: string
  author?: string
  company?: string
  asset?: any
}

export type TestimoniesProps = {
  variant?: 'primary' | 'secondary' | 'tertiary' | 'quaternary'
  title?: string
  items: TestimoniesItems[]
}

export const PhnxTestimonies: React.FC<TestimoniesProps> = ({
  variant = 'primary',
  title,
  items,
}) => {
  const getIconComponent = (variant: TestimoniesItems['variant']) => {
    switch (variant) {
      case 'primary':
        return <QuoteAquaIcon />
      case 'secondary':
        return <QuoteGreenIcon />
      case 'tertiary':
        return <QuotePurpleIcon />
      default:
        return null
    }
  }

  const [assetDimensions, setAssetDimensions] = useState<{ width: number; height: number } | null>(
    null
  )
  const assetRef = useRef<HTMLDivElement>(null)
  const [keyID, setKeyID] = useState<string>(items[0].asset.src)

  useEffect(() => {
    if (assetRef.current) {
      setAssetDimensions({
        width: assetRef.current.offsetWidth,
        height: assetRef.current.offsetHeight,
      })
    }
    console.warn('keyID', setKeyID)
  }, [])

  return (
    <div className={`${styles['testimonies']} ${styles[`variant-${variant}`]}`}>
      <div className={`container ${styles[`testimonies-${variant}`]}`}>
        <div className={styles['testimonies-title']}>{title}</div>
        <div className={styles['testimonies-items']}>
          {items.map((item, index) =>
            variant === 'tertiary' || item.variant === 'quaternary' ? (
              <div
                className={`${styles[`testimonies-item-${item.variant}`]}`}
                key={`testimonial` + index}
              >
                <div className={styles['testimonies-text']}>
                  <div className={styles['testimonies-description']}>{item.description}</div>
                  <div className={styles['testimonies-author']}>{item.author}</div>
                  <div className={styles['testimonies-company']}>{item.company}</div>
                </div>
                {item.asset && (
                  <div className={styles['testimonies-asset']} ref={assetRef}>
                    <PhnxImageHolder
                      key={keyID}
                      images={[
                        {
                          src: item.asset.src,
                          alt: item.asset.alt,
                          focus: item.asset.focus,
                        },
                      ]}
                      maximumHeight={assetDimensions?.height}
                      maximumWidth={assetDimensions?.width}
                    />
                  </div>
                )}
              </div>
            ) : (
              <div className={styles['testimonies-item']} key={`testimonial` + index}>
                <div>{getIconComponent(item.variant)}</div>
                <div className={styles['testimonies-description']}>{item.description}</div>
                <div className={styles['testimonies-author']}>{item.author}</div>
                <div className={styles['testimonies-company']}>{item.company}</div>
              </div>
            )
          )}
        </div>
      </div>
    </div>
  )
}
